import { IErmDevOpsApiClientServiceConfig } from './erm-devops-api-client.service-config';
import { ErmDevOpsApiClientService } from './erm-devops-api-client.service';
import { IErmApiClientConfig } from '../erm-api-client-config';
import { ErmApiClientBuilderService } from '../erm-api-client-builder.service';

export function ErmDevOpsApiClientServiceFactory(apiClientConfig: IErmApiClientConfig, builder: ErmApiClientBuilderService): ErmDevOpsApiClientService {
  const config: IErmDevOpsApiClientServiceConfig = {
    baseUrl: apiClientConfig.ermDevOpsApiBaseUrl,
    enableLogging: true,
    authHeaderResolver: apiClientConfig.authHeaderResolver
  };
  return new ErmDevOpsApiClientService(config, builder);
}
